/*

Class for generating a user

https://www.hl7.org/fhir/person.html

{
  "state" : "<code>" // active || pending || archive || delete
  "userType" : "<code>", // orgAdmin || providerAP || providerLP || patient
  "userId" : "<String>"
  "orgId" : { Reference(Organization) }, // The organization that is the custodian of the person record
  "name" : [{ HumanName }], // A name associated with the person
  "sex" : "<code>", // male | female | transmale | transfemale | other | unknown
  "gender" : "<code>", // male | female | nonbinary | other | unknown
  "birthdate" : "<date>", // The date on which the person was born
  "telecom" : [{ ContactPoint }], // A contact detail for the person
}

*/

// Import libraries
const Joi = require('joi');

// Import variables
const { STATES, USER_TYPES } = require('@bcm/constants');
const { DataTableBase } = require('./base.class');
const { identifiers } = require('../datastructComponents');

// Create schema
const schema = {
  identifier: Joi.any().optional(),
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  userType: Joi.string().valid( ...Object.keys(USER_TYPES) ).required(),
  userId: Joi.string().required(),
  pin: Joi.string().required(),
};

// Define class
class UserPin extends DataTableBase {
  constructor ( obj ) {
    super(
      identifiers.userPin.buildPk(obj.userId),
      identifiers.userPin.buildSk(obj.state, obj.userType, obj.userId)
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.UserPin = UserPin;
exports.userPinSchema = schema;